import { useState, useEffect } from "react";

const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState("");

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      let size = "";

      if (screenWidth < 480) {
        size = "sm";
      } else if (screenWidth >= 440 && screenWidth < 768) {
        size = "md";
      } else if (screenWidth >= 768 && screenWidth < 992) {
        size = "lg";
      } else {
        size = "xl";
      }

      setScreenSize(size);
    };

    handleResize(); // Initial call to set screen size on component mount

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array to run the effect only once on component mount

  return screenSize;
};

export default useScreenSize;
